module.exports = __webpack_public_path__ + "img/과학기술정보통신부_혼합_좌우.b8716b80.jpg";